// Central site constants
export const LOGO_URL = "/perez-logo.png";

export const BUSINESS = {
  name: "Perez Electric",
  slogan: "Powered by Precision. Wired for Excellence.",
  phone: "431-554-5824",
  phoneHref: "tel:+14315545824",
  email: "info@perezelectric.org",
  emailHref: "mailto:info@perezelectric.org",
};

export const SERVICES_LIST = [
  {
    slug: "ev-chargers",
    title: "EV Charger Installations",
    blurb:
      "Level 2 home chargers, commercial pedestals, load calculations and permits — wired clean, certified, and future-ready.",
    icon: "Zap",
    image:
      "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "residential",
    title: "Residential Wiring",
    blurb:
      "New builds, renovations, knob-and-tube replacement, outlets, switches, and full re-wires done to code.",
    icon: "Home",
    image:
      "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "commercial",
    title: "Commercial & Industrial",
    blurb:
      "Tenant fit-ups, three-phase service, machine connections, and maintenance contracts that keep your operation humming.",
    icon: "Building2",
    image:
      "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "panel-upgrades",
    title: "Panel & Service Upgrades",
    blurb:
      "100A → 200A upgrades, sub-panels, dedicated circuits, surge protection and main service replacements.",
    icon: "Cpu",
    image:
      "https://images.unsplash.com/photo-1473308822086-710304d7d30c?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "lighting",
    title: "Lighting Services",
    blurb:
      "Interior and exterior LED, pot light retrofits, dimmers, landscape lighting and architectural feature lighting.",
    icon: "Lightbulb",
    image:
      "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "troubleshooting",
    title: "Troubleshooting & Repair",
    blurb:
      "Tripping breakers, dead outlets, flickering lights, hot panels — diagnosed methodically and fixed right.",
    icon: "Wrench",
    image:
      "https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "new-builds",
    title: "New Builds",
    blurb:
      "Ground-up residential and commercial electrical packages — service entrance, rough-in, finish, inspections and final connections, fully coordinated with your builder.",
    icon: "Hammer",
    image:
      "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "saunas",
    title: "Sauna Wiring",
    blurb:
      "Dedicated 240V circuits, proper conductor sizing, GFCI/AFCI protection and approved disconnects for residential and commercial sauna installs.",
    icon: "Flame",
    image:
      "https://images.unsplash.com/photo-1610650394641-9b35d8b0c4e0?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "smart-home",
    title: "Smart Home & Automation",
    blurb:
      "Smart switches, networked lighting, smoke/CO interconnects, EV-ready garages and integrated controls.",
    icon: "Cable",
    image:
      "https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "hot-tub-pool",
    title: "Hot Tub & Pool Wiring",
    blurb:
      "GFCI-protected dedicated circuits, bonding, disconnects and inspections — safe wiring for water and power.",
    icon: "Waves",
    image:
      "https://images.unsplash.com/photo-1545569310-9fd2ae87df5b?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "emergency",
    title: "Emergency Calls",
    blurb:
      "We do our best to respond fast when power fails or things spark. Emergency response is available but not guaranteed.",
    icon: "Siren",
    image:
      "https://images.unsplash.com/photo-1542621334-a254cf47733d?auto=format&fit=crop&w=1200&q=80",
  },
  {
    slug: "inspections",
    title: "Inspections & Code",
    blurb:
      "Pre-purchase electrical inspections, deficiency reports, and corrections to bring older systems up to code.",
    icon: "ClipboardCheck",
    image:
      "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=1200&q=80",
  },
];

export const GALLERY_IMAGES = [
  {
    src: "https://images.unsplash.com/photo-1565608438257-fac3c27beb36?auto=format&fit=crop&w=1400&q=80",
    alt: "Electrician working on a panel",
  },
  {
    src: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?auto=format&fit=crop&w=1400&q=80",
    alt: "EV charger plugged into vehicle",
  },
  {
    src: "https://images.unsplash.com/photo-1473308822086-710304d7d30c?auto=format&fit=crop&w=1400&q=80",
    alt: "Modern electrical panel install",
  },
  {
    src: "https://images.unsplash.com/photo-1513506003901-1e6a229e2d15?auto=format&fit=crop&w=1400&q=80",
    alt: "Warm pot lighting in a modern home",
  },
  {
    src: "https://images.unsplash.com/photo-1621905251918-48416bd8575a?auto=format&fit=crop&w=1400&q=80",
    alt: "Tools and wires on a workbench",
  },
  {
    src: "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1400&q=80",
    alt: "Residential rough-in wiring",
  },
];
